import React, {useEffect} from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {setMultiLoader} from "../../actions/actionFunctions";
import MultiLoaderSteps from "./multiLoaderSteps";
import MaterialSpinner from "./materialSpinner";

const MultiLoader = (props) => {

  const {multiLoader, setMultiLoader, useCabinetLoader} = props;

  useEffect(() => {
    setMultiLoader({finished: false, activeStep: 0, visible: true});
    return () => {
      setMultiLoader({finished: true, activeStep: 0});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (multiLoader.activeStep > multiLoader.renderSteps.length) {
  //     setTimeout(() => {
  //       setMultiLoader({visible: false});
  //     }, 500)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [multiLoader.activeStep]);

  if (!multiLoader.visible) {
    return null
  }

  if (multiLoader.finished) {
    return <MaterialSpinner/>
  }

  return (
    <div className="multi-loader__overlay">
      <MultiLoaderSteps useCabinetLoader={useCabinetLoader}/>
    </div>
  )
};

MultiLoader.propTypes = {
  useCabinetLoader: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {multiLoader} = store.loaderState;
  return {
    multiLoader,
  };
};

const mapDispatchToProps = {
  setMultiLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiLoader)
